var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7836 4.57499C14.6528 4.42002 11.5284 0.785156 7.53423 0.785156C3.53994 0.785156 0.415642 4.42002 0.2846 4.57514C0.027504 4.879 0.027504 5.31989 0.284751 5.62405C0.415642 5.77902 3.53994 9.41373 7.53423 9.41373C11.5284 9.41373 14.6528 5.77871 14.7837 5.62375C15.0408 5.31989 15.0408 4.879 14.7836 4.57499ZM8.75426 2.96866C9.02285 2.82129 9.39738 2.99039 9.59069 3.3462C9.78401 3.70217 9.72295 4.11024 9.45436 4.25761C9.18593 4.40514 8.81124 4.23589 8.61778 3.88007C8.42462 3.52411 8.48553 3.11603 8.75426 2.96866ZM7.53423 8.09682C4.74411 8.09682 2.39608 5.94295 1.58338 5.09944C2.13219 4.52972 3.38169 3.36306 4.99425 2.66541C4.67972 3.14642 4.49532 3.72116 4.49532 4.33981C4.49532 6.02681 5.85577 7.39431 7.53408 7.39431C9.21238 7.39431 10.573 6.02681 10.573 4.33981C10.573 3.72116 10.3887 3.14642 10.0742 2.66541C11.6868 3.36322 12.9361 4.52972 13.4849 5.09944C12.6722 5.9434 10.3242 8.09682 7.53423 8.09682Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.083363bfe3810e0a614c2ae4663c8bcb.svg";
export { ForwardRef as ReactComponent };